<template>
	<div class="c-global-search-autosuggestions__box"
		 v-if="globalAutoSuggestSearchResults.length || noAutocompleteItems"
		 ref="autosuggestionsDropDown">
		<ul
			v-if="globalAutoSuggestSearchResults.length"
			class="c-global-search-autosuggestions__wrapper c-global-search-autosuggestions__results"
			id="autosuggest-list"
			role="listbox"
			aria-live="polite">
			<global-search-autoSuggest-item
											 v-for="(card, index) in globalAutoSuggestSearchResults"
										     :key="`card.heading-${index}`"
										     :card="card"
											 :ref="'card-' + card.id" />
		</ul>
		<div
			 v-if="noAutocompleteItems"
			 class="c-global-search-autosuggestions__wrapper c-global-search-autosuggestions__empty"
			 >
			<h3 class="c-global-search-autosuggestions__title">{{ globalSearchModel.NoSearchResultsHeadline }}</h3>
			<p>{{ globalSearchModel.NoSearchResultsText }}</p>
		</div>
	</div>
</template>

<script>
	import globalSearchAutoSuggestItem from 'shared/components/globalSearch/globalSearchAutosuggestItem.vue';
	import { mapGetters, mapActions } from 'vuex';

	export default {
		name: 'global-search-autoSuggest-dropDown-list',
		components: {
			globalSearchAutoSuggestItem,
		},
		computed: {
			...mapGetters({
				globalSearchModel: 'getGlobalSearchModel',
				globalAutoSuggestSearchResults: 'getGlobalAutoSuggestSearchResults',
				isSearchPage: 'getIsSearchPage',
				noAutocompleteItems: 'getNoAutocompleteItems',
				selectedSuggestionIndex: 'getSelectedSuggestionIndex'
			}),
		},
		methods: {
			...mapActions([
				'autoSuggestGlobalSearch',
				'cancelAutosuggestionSearch',
			]),
			focusControl(id) {
				// If the dropdown is visible
				if (this.globalAutoSuggestSearchResults?.length || this.noAutocompleteItems) {
					this.$nextTick(() => {
						if (id) {
							this.$refs[`card-${id}`][0].focusElement();
						}
					});
				}
			},
		},
		watch: {
			selectedSuggestionIndex(newIndex) {
				if ( newIndex >= 0 ) {
					this.focusControl(this.globalAutoSuggestSearchResults[newIndex].id)
				}
			}
		}
	};
</script>
